import { defaultProvider } from '@store/web3Store/web3Store.variables';
import { StarknetWindowObject, getStarknet } from 'get-starknet-core';
import { IStarknetProvider } from './starknetStore.type';

async function _connectStarknetWallet(wallet: StarknetWindowObject): Promise<{
	provider: IStarknetProvider;
	error?: any;
}> {
	const starknet = getStarknet();

	let _provider: IStarknetProvider = { ...defaultProvider };

	const enabledWallet = await starknet.enable(wallet, {
		starknetVersion: 'v5'
	});

	_provider.web3Provider = enabledWallet.provider.provider ? enabledWallet.provider.provider : enabledWallet.provider;
	_provider.web3Instance = enabledWallet;
	_provider.web3Instance.provider = _provider.web3Provider;
	_provider.error = false;

	if (!_provider.web3Provider) throw new Error('No provider');

	return {
		provider: _provider,
		error: undefined
	};
}

export { _connectStarknetWallet };
